module.exports = __webpack_public_path__ + "img/gradient-light.7045d1b7.jpg";